import * as d3 from 'd3';

// TODO: replace the 800 ms transition time everywhere with a this.transitionTime variable

var groupedBar = function (opts) {
	//so we can revert after we have removed Data from dom
	this.masterData = opts.data;
	this.masterTargetData = opts.targetData || [];
	
	//create an array to fix order of groups
	this.uniqueGroups = this.masterData.map(function (d) {
		return d.group
	})
			.filter(function (d, i, self) {
				return self.indexOf(d) === i;
			})
	
	//used to generate bars
	this.data = JSON.parse(JSON.stringify(this.masterData))
	
	//used to generate targets
	this.targetData = JSON.parse(JSON.stringify(this.masterTargetData))
	
	this.chartData = this.rollData(this.data);
	this.chartTargetData = this.rollData(this.targetData);
	
	
	console.log("chart data", this.data)
	
	this.targetColor = opts.targetColor || 'purple';
	
	
	/*
	there are THREE ways to set color in this chart.
	1) Pass a hex code directly in each data variable with the color key.
	2) Pass an array of colors in the opts variable on initialization, which is assigned to each bar through a color scale
	3) Pass nothing, default to d3.schemaCategory20
	 */
	
	this.colorSet = opts.colorSet;
	
	this.labelRound = opts.labelRound || 0;
	
	this.width = opts.width || 960;
	this.height = opts.height || 500;
	this.padding = {left: this.width * .09, right: this.width * .05, top: this.height * .05, bottom: this.height * .1}
	
	this.t = d3.transition().duration(1000)
	
	this.chartHeight = this.height - this.padding.bottom - this.padding.top;
	this.chartWidth = this.width - this.padding.right - this.padding.left;
	
	this.chartMaxVal = opts.chartMaxVal || null;
	
	this.legendBindPoint = opts.bindLegendTo || opts.bindTo;
	this.legend = d3.select(this.legendBindPoint).append('div').classed('bar-chart-legend', true);
	
	
	this.svg = d3.select(opts.bindTo).append("svg")
			.attr("preserveAspectRatio", "xMinYMin meet")
			.attr("viewBox", "0 0 " + this.width + " " + this.height)
			.classed("svg-content", true);
	
	this.wrappergroup = this.svg.append("g").attr("transform", "translate(" + this.padding.left + "," + this.padding.top + ")");
	
	//percent of difference between extent that we would like shown.
	// so that low point is not at zero line and max is not all the way at top.
	this.dataPadding = .2;
	this.update(this.data, this.targetData);
}


//nests the data by group.
groupedBar.prototype.rollData = function (data) {
	var _this = this;
	
	
	var nested_data = d3.nest()
			.key(function (d) {
				return d.group;
			}).sortKeys(d3.descending)
			.entries(data);
	
	//ensure consistent sorting
	nested_data.sort(function (a, b) {
		return _this.uniqueGroups.indexOf(a.key) < _this.uniqueGroups.indexOf(b.key)
	})
	
	
	return nested_data;
}


groupedBar.prototype.setScales = function () {
	var _this = this;
	var data = _this.data.concat(_this.targetData)
	
	var extent = d3.extent(data.map(function (d) {
		return d.value
	}));
	
	var axisExtent = [];
	
	var calculatedDataPadding = (extent[1] - extent[0]) * _this.dataPadding;
	
	axisExtent[0] = extent[0] - calculatedDataPadding >= 0 ? extent[0] - calculatedDataPadding : 0;
	axisExtent[1] = (_this.chartMaxVal && extent[1] + calculatedDataPadding > _this.chartMaxVal) ? _this.chartMaxVal : extent[1] + calculatedDataPadding;
	
	_this.y = d3.scaleLinear()
			.range([_this.height - _this.padding.top - _this.padding.bottom, 0])
			.domain(axisExtent);
	
	
	_this.x0 = d3.scaleBand()
			.rangeRound([0, _this.width - this.padding.left - this.padding.right])
			.paddingInner(0.1)
			.domain(data.map(function (d) {
				return d.group
			}));
	
	
	
	//set of master data! very important to keep consistency with color and legend
	_this.metricsdomain = d3.set(_this.data.map(function (d) {
		return d.label
	})).values();
	_this.displayedmetricsdomain = d3.set(_this.data.sort(function (a, b) {
		return (a.value < b.value) ? -1 : (a.value > b.value) ? 1 : 0
	}).map(function (d) {
		return d.label
	})).values();
	
	_this.x1 = d3.scaleBand()
			.rangeRound([0, _this.x0.bandwidth()])
			.domain(_this.displayedmetricsdomain)
			.padding(0.05);
	
	
	_this.colorSet = []
	
	_this.metricsdomain.forEach(m => {
		const match = this.data.filter(d => d.label === m)
		if (match.length) _this.colorSet.push(match[0].color)
	})
	
	_this.barColor = d3.scaleOrdinal()
			.domain(_this.metricsdomain)
			.range(_this.colorSet || d3.schemeCategory20c)
	
	console.log("color scale", _this.barColor.range(), _this.barColor.domain())
}


groupedBar.prototype.updateBars = function () {
	var _this = this;
	
	var data = _this.chartData;
	
	_this.bargroups = _this.wrappergroup
			.selectAll("g.bargroup")
			.data(_this.chartData, function (d) {
				return d.key
			})
	
	
	_this.bargroups
			.transition(_this.t)
			.attr('width', function () {
				return _this.x0.bandwidth()
			})
	
	
	//exit
	_this.bargroups.exit()
			.remove();
	
	//enter
	var newbargroups = _this.bargroups
			.enter().append("g")
			.attr('class', 'bargroup')
			.attr('width', function () {
				return _this.x0.bandwidth()
			});
	
	
	//enter + update
	_this.bargroups = newbargroups
			.merge(_this.bargroups)
			.attr("transform", function (d) {
				return "translate(" + _this.x0(d.key) + ",0)";
			})
	
	
	var bars = _this.bargroups
			.selectAll('g.bar')
			.data(function (d) {
				return d.values;
			}, function (d) {
				return d.label
			})
	
	bars
			.attr('fill', function (d) {
				return _this.barColor(d.label)
			})
	
	
	//exit
	bars.exit()
			.remove();
	
	
	//enter selection
	var newbars = bars
			.enter().append('g').classed('bar', true)
	
	newbars
			.append("rect")
			.attr('height', 0)
			.attr("y", _this.chartHeight)
	
	
	newbars
			.append('text')
			.text(function (d) {
				return (+d.value).toFixed(_this.labelRound)
			})
			.attr("opacity", 0);
	
	//enter and update merge selection
	bars = newbars
			.merge(bars)
	
	var rects = bars
			.selectAll('rect')
			.attr("metric", function (d) {
				return d.label
			})
			.attr("x", function (d) {
				return _this.x1(d.label);
			})
			.attr("width", _this.x1.bandwidth())
			.attr('fill', function (d) {
				return _this.barColor(d.label)
			})
	
	rects.classed(function (d) {
		return d.label.replace(" ", "_")
	}, true);
	
	rects.on('mouseover', function () {
		var metric = d3.select(this).attr("metric")
		var focused_rects = _this.svg.selectAll('[metric="' + metric + '"]').classed('barfocus', false);
		focused_rects.attr('stroke', function () {
			return d3.hsl(d3.select(this).attr('fill')).darker()
		}).attr("stroke-width", 3);
		
		var legend_i = _this.legend.selectAll('[metric="' + metric + '"]').style('font-weight', 'bolder');
	})
	
	rects.on('mouseout', function () {
		var metric = d3.select(this).attr("metric")
		var focused_rects = _this.svg.selectAll('[metric="' + metric + '"]').classed('barfocus', false);
		focused_rects.attr('stroke', function () {
			return d3.hsl(d3.select(this).attr('fill'))
		})
				.attr("stroke-width", 0);
		
		var legend_i = _this.legend.selectAll('[metric="' + metric + '"]').style('font-weight', 'normal');
		
	})
	
	
	rects
			.transition(_this.t)
			.attr("height", function (d) {
				return _this.chartHeight - _this.y(d.value);
			})
			.attr("y", function (d) {
				return _this.y(d.value)
			})
	
	
	var barlabels = bars.select('text')
			.attr("x", function (d) {
				return _this.x1(d.label) + _this.x1.bandwidth() / 2
			})
			.attr("y", function (d) {
				return _this.y(d.value) + 20
			})
			.style("text-anchor", "middle")
			.style("fill", "#FFF")
	
	//hide if it is too close to the bottom
	
	
	barlabels.transition().delay(300).duration(600)
			.attr("opacity", function (d) {
				return (_this.y(d.value) > _this.chartHeight - 20) ? 0 : 1
			});
	
	
	///add number labels to bars.
	
	
}


groupedBar.prototype.updateTargets = function () {
	var _this = this;
	
	var data = _this.chartTargetData;
	
	
	_this.targetgroups = _this.wrappergroup
			.selectAll("g.targetGroup")
			.data(data, function (d) {
				return d.key
			})
	
	_this.targetgroups
			.transition(_this.t)
			.attr('width', function () {
				return _this.x0.bandwidth()
			})
	
	//exit
	_this.targetgroups.exit()
			.remove();
	
	//enter
	var newtargetgroups = _this.targetgroups
			.enter().append("g")
			.attr('class', 'targetGroup')
			.attr('width', function () {
				return _this.x0.bandwidth()
			});
	
	
	//enter + update
	_this.targetgroups = newtargetgroups
			.merge(_this.targetgroups)
			.attr("transform", function (d) {
				return "translate(" + _this.x0(d.key) + ",0)";
			})
	
	
	var targets = _this.targetgroups
			.selectAll('.target')
			.data(function (d) {
				return d.values;
			}, function (d) {
				return d.label
			})
	
	//exit
	targets.exit()
			.remove();
	
	
	//enter selection
	var newtargets = targets
			.enter().append("rect")
			.classed('target', true)
			.attr('height', 1)
			.attr("y", _this.chartHeight)
	
	//enter and update merge selection
	targets = newtargets
			.merge(targets)
			.attr("metric", function (d) {
				return d.label
			})
			.attr("x", function (d) {
				return _this.x1(d.label);
			})
			.attr("width", _this.x1.bandwidth())
			.attr('stroke', function (d) {
				return _this.targetColor
			})
			.attr('fill', function (d) {
				return _this.targetColor
			})
	//fill is only referenced by hover over effect,
	// to allow an easier function
	
	targets
			.transition(_this.t)
			.attr("y", function (d) {
				return _this.y(d.value)
			})
	
}


groupedBar.prototype.setAxes = function (ticks) {
	
	var _this = this;
	if (!ticks || isNaN(ticks)) ticks = 10;
	_this.ticks = ticks;
	
	_this.yAxis = d3.axisLeft(_this.y)
			.tickSizeInner(-_this.width + _this.padding.left)
			.tickSizeOuter(0);
	
	_this.xAxis = d3.axisBottom(_this.x0)
			.tickValues(_this.x0.domain())
			.tickSize(0);
}


//also calls the listener function
groupedBar.prototype.editAxesStyle = function () {
	var _this = this;
	_this.axes.select('.domain').attr('opacity', 0);
	_this.axes.selectAll('.tick').select('line').attr('opacity', .2);
	_this.axes.select('.y').selectAll('.tick').selectAll('text')
			.attr('dx', _this.width * .035)
			.attr('dy', -(_this.chartHeight / _this.ticks) * .1)
}


groupedBar.prototype.initializeAxes = function () {
	
	var _this = this;
	_this.setAxes()
	
	_this.axes = _this.wrappergroup.append('g')
			.classed('axes', true)
	
	_this.axes.append('g')
			.classed('y axis', true)
			.attr('transform', 'translate(-' + _this.padding.left / 2 + ',0)')
			.attr('opacity', 0)
			.call(_this.yAxis)
			.transition(_this.t)
			.attr('opacity', 1);
	
	
	var xaxisypoint = _this.chartHeight;
	
	_this.axes.append('g')
			.classed('x axis', true)
			.attr('transform', 'translate(0,' + xaxisypoint + ')')
			.call(_this.xAxis);
	
	_this.editAxesStyle();
}


groupedBar.prototype.updateAxes = function () {
	var _this = this;
	_this.setAxes()
	
	
	_this.svg.select(".x")
			.transition(_this.t)
			.call(this.xAxis)
	
	_this.svg.select(".y")
			.transition(_this.t)
			.call(this.yAxis)
	
	_this.editAxesStyle();
	
}


// this basically is not in use in the current drag and drop system.
groupedBar.prototype.setLegend = function () {
	var _this = this;
	
	//add header if it's our first run
	if (!_this.legend.classed('initialized')) {
		var legenditems_wrapper = _this.legend.append('div').classed('legend-section-wrapper', true)
		
		var legenditem_header = legenditems_wrapper.append('div')
				.classed('legend-header', true).text('Metrics')
		
		legenditems_wrapper = legenditems_wrapper
				.append('div').classed('legend-item-wrapper metric-wrapper', true)
	} else {
		legenditems_wrapper = _this.legend.select('metric-wrapper')
	}
	
	var legenditems = legenditems_wrapper.selectAll('.metriclegenditem')
			.data(_this.metricsdomain, function (d) {
				return d;
			})
	
	legenditems.exit().remove();
	
	var newlegenditems = legenditems.enter()
			.append('div').attr('class', 'barchartlegenditem metriclegenditem')
			.attr('metric', function (d) {
				return (d)
			});
	
	
	var newcircles = newlegenditems
			.append('svg').attr('width', 8).attr('height', 8)
			.append('g').attr('transform', 'translate(4,4)')
			.append('circle').attr('r', 4)
			.attr('fill', function (d) {
				var assignedcolor = _this.masterData.filter(function (a) {
					return a.metric == d
				})[0].color
				return assignedcolor ? assignedcolor : _this.barColor(d);
			})
			.attr('stroke', function () {
				return d3.hsl(d3.select(this).attr('fill')).darker()
			})
			.attr('stroke-width', 1);
	
	newlegenditems
			.append('div').classed('label', true)
			.html(function (d) {
				return d
			})
	
	
	var circles = legenditems.selectAll('circle');
	
	
	legenditems = newlegenditems
			.merge(legenditems)
	
	
	////////////////////
	/// This section deals with appending groups.
	//////////////////
	
	_this.keyset = d3.set(_this.masterData.map(function (d) {
		return d.group
	})).values()
	
	
	if (!_this.legend.classed('initialized')) {
		var groupitems_wrapper = _this.legend.append('div').classed('legend-section-wrapper group-section', true)
		
		var groupitems_header = groupitems_wrapper.append('div')
				.classed('legend-header', true).text('Time Periods')
		groupitems_wrapper = groupitems_wrapper
				.append('div').classed('legend-item-wrapper group-wrapper', true)
	} else {
		groupitems_wrapper = _this.legend.select('group-wrapper')
	}
	
	var groupitems = groupitems_wrapper.selectAll('.grouplegenditem')
			.data(_this.keyset, function (d) {
				return d;
			})
	
	groupitems.exit().remove();
	
	var newgroupitems = groupitems.enter()
			.append('div').attr('class', 'barchartlegenditem grouplegenditem')
			.attr('group', function (d) {
				return (d)
			});
	
	
	var newsquares = newgroupitems
			.append('svg').attr('width', 8).attr('height', 8)
			.append('g').attr('transform', 'translate(4,4)')
			.append('circle').attr('r', 4)
			.attr('fill', function (d, i) {
				return ["#d3e3d2", "#bccabb", "#a4b1a3", "#8d978c", "#757e75"][i]
			})
			.attr('stroke', function () {
				return d3.hsl(d3.select(this).attr('fill')).darker()
			})
			.attr('stroke-width', 1);
	
	newgroupitems
			.append('div').classed('label', true)
			.html(function (d) {
				return d
			})
	
	
	var circles = groupitems.selectAll('circle');
	
	
	groupitems = newgroupitems
			.merge(groupitems)
	
	
	function groupClicked() {
		var t = d3.select(this);
		var group = t.select('.label').text();
		
		if (t.classed('notactive')) {
			var filterfunc = function (d) {
				return d.group == group
			}
			
			var pushData = _this.masterData.filter(filterfunc);
			var pushTargetData = _this.masterTargetData.filter(filterfunc);
			
			var newData = _this.data.concat(pushData);
			var newTargetData = _this.targetData.concat(pushTargetData);
			t.classed('notactive', false);
			_this.update(newData, newTargetData);
			
		} else {
			var filterfunc = function (d) {
				return d.group != group
			}
			
			_this.data = _this.data.filter(filterfunc);
			_this.targetData = _this.targetData.filter(filterfunc);
			t.classed('notactive', true);
			
			_this.update(_this.data, _this.targetData);
		}
	}
	
	
	//now we apply the legend listeners
	
	function clicked() {
		var t = d3.select(this),
				metric = t.attr('metric');
		
		if (t.classed('notactive')) {
			var datatoadd = _this.masterData.filter(function (d) {
				return d.label == metric
			});
			var targetdatatoadd = _this.masterTargetData.filter(function (d) {
				return d.label == metric
			});
			
			datatoadd.forEach(function (d) {
				_this.data.push(d);
			})
			
			targetdatatoadd.forEach(function (d) {
				_this.targetData.push(d);
			})
			
			t.classed('notactive', false);
			_this.update(_this.data, _this.targetData, false);
			
		} else {
			t.classed('notactive', true);
			_this.data = _this.data.filter(function (d) {
				return d.label != metric
			});
			_this.targetData = _this.targetData.filter(function (d) {
				return d.label != metric
			});
			_this.update(_this.data, _this.targetData, false);
			
		}
	}
	
	legenditems.on('click', clicked);
	groupitems.on('click', groupClicked);
	
	
	legenditems.on('mouseover', function () {
		var metric = d3.select(this).attr("metric")
		var focused_rects = _this.svg.selectAll('[metric="' + metric + '"]').classed('barfocus', false);
		focused_rects.attr('stroke', function () {
			return d3.hsl(d3.select(this).attr('fill')).darker()
		})
				.attr("stroke-width", 4);
		
		
		var legend_i = _this.legend.selectAll('[metric="' + metric + '"]').style('font-weight', 'bolder');
	})
	
	legenditems.on('mouseout', function () {
		var metric = d3.select(this).attr("metric")
		var focused_rects = _this.svg.selectAll('[metric="' + metric + '"]').classed('barfocus', false);
		focused_rects.attr('stroke', function () {
			return d3.hsl(d3.select(this).attr('fill'))
		})
				.attr("stroke-width", 2);
		
		var legend_i = _this.legend.selectAll('[metric="' + metric + '"]').style('font-weight', 'normal');
		
	})
	
	_this.legend.classed('initialized', true);
	
	
}


groupedBar.prototype.update = function (data, targetData, resetData) {
	if (!resetData) resetData == false;
	
	
	if (resetData) {
		this.masterData = data;
		this.masterTargetData = targetData || [];
		this.data = JSON.parse(JSON.stringify(this.masterData))
		this.targetData = JSON.parse(JSON.stringify(this.masterTargetData))
	}
	else {
		this.data = data;
		this.targetData = targetData || [];
	}
	this.setScales();
	this.chartData = this.rollData(this.data);
	this.chartTargetData = this.rollData(this.targetData)
	
	if (!this.svg.selectAll('.axes').size()) {
		this.initializeAxes();
	} else {
		this.updateAxes();
	}
	this.updateBars();
	this.updateTargets();
	
}


groupedBar.prototype.setTargetData = function (data, color) {
	var _this = this;
	_this.masterTargetData = data;
	if (color) this.targetColor = color;
	//some bars may have been turned off, so I need to make sure that the targets that are appended match the bars being shown.
	//we keep track of this with this.displayedmetricsdomain
	//var newTargetData =  _this.masterTargetData.filter(function(d) { return _this.displayedmetricsdomain.indexOf(d.label) >= 0 });
	this.update(_this.data, _this.masterTargetData);
}


export default groupedBar;



